/* eslint-disable no-nested-ternary */
import React from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { isMarketsPage, isTradePage } from 'helpers/utils';

import styles from './index.module.scss';

const SignUpLoginTab = () => {
  const { t } = useTranslation(['headerFooter']);
  const history = useHistory();
  const location = useSelector(state => state.router.location);

  const handleLoginClick = () => {
    trackMixpanelEvent('Login - Header', {
      page_name: 'All Markets Page',
    });
    history.push({ pathname: routes.login, state: { from: location } });
  };

  const handleSignUpClick = () => {
    trackMixpanelEvent('Signup Page - Form Opened', {
      site_demarkation: 'Web App',
      page_name: isMarketsPage()
        ? 'All Markets Page'
        : isTradePage
        ? 'Trade Page'
        : `Others- Web App`,
    });
    history.push({ pathname: routes.signup, state: { from: location } });
  };

  return (
    (<div
      className={styles['signin-register-container']}
      id="login-register-container"
      data-palette="SignUpLoginTab">
      <button
        data-testid="header-login"
        className={`naked pointer ${styles.signin}`}
        onClick={handleLoginClick}
        type="button"
      >
        {t('headerFooter:header.logIn')}
      </button>
      <button
        data-testid="header-signup"
        className={`naked pointer ${styles.register}`}
        onClick={handleSignUpClick}
        type="button"
      >
        {t('headerFooter:header.signUp')}
      </button>
    </div>)
  );
};

export default SignUpLoginTab;
